import { PlusCircle } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import { AssetCategoryList } from 'components/assetCategories/AssetCategoryList';
import { useAssetCategories, useUpdateAssetCategory } from 'hooks/useAssets';
import { AssetCategory } from 'shared/types/asset';
import { toast } from 'react-toastify';
import { Button } from '@/components/ui/button';

const AssetCategoriesTab = () => {
  const navigate = useNavigate();
  const { categories, isLoading, refetch } = useAssetCategories();
  const { updateCategory } = useUpdateAssetCategory();

  const handleEdit = (category: AssetCategory) => {
    navigate(`/settings/voorzieningen-categorieen/${category.id}`);
  };

  const handleDeactivate = async (category: AssetCategory) => {
    try {
      await updateCategory(category.id.toString() as unknown as string, {
        active: !category.active,
      });
      toast.success(
        category.active
          ? `Categorie "${category.name}" gedeactiveerd`
          : `Categorie "${category.name}" geactiveerd`
      );
      refetch();
    } catch (error) {
      toast.error('Fout bij (de)activeren van categorie');
    }
  };

  return (
    <div className="flex flex-col gap-6">
      {/* Header with Create Button */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold text-foreground">
            Voorzieningen Categorieën
          </h2>
          <p className="text-sm text-muted-foreground mt-1">
            Beheer categorieën, types en velden voor voorzieningen
          </p>
        </div>
        <Button onClick={() => navigate('/settings/voorzieningen-categorieen/nieuw')}>
          <PlusCircle className="h-4 w-4 mr-2" />
          Nieuwe Categorie
        </Button>
      </div>

      {/* Categories List */}
      <AssetCategoryList
        categories={categories}
        onEdit={handleEdit}
        onDeactivate={handleDeactivate}
        isLoading={isLoading}
      />
    </div>
  );
};

export default AssetCategoriesTab;
